import { create } from "zustand";

interface State {
  /** The task currently offered an "Insert" button, and the parent to insert into. */
  active: { taskId: string; parentId: string } | null;
  /** Offer the button for `taskId`; auto-dismisses after 2s (resets the timer on
   *  a fresh offer). Non-blocking — nothing else cancels it early. */
  offer: (taskId: string, parentId: string) => void;
  dismiss: () => void;
}

let timer: ReturnType<typeof setTimeout> | undefined;

export const useInsertPromptStore = create<State>((set) => ({
  active: null,
  offer: (taskId, parentId) => {
    if (timer) clearTimeout(timer);
    set({ active: { taskId, parentId } });
    timer = setTimeout(() => { timer = undefined; set({ active: null }); }, 2000);
  },
  dismiss: () => {
    if (timer) { clearTimeout(timer); timer = undefined; }
    set({ active: null });
  },
}));
